import { CsvSyncButton } from 'components/CsvButtons';
import { useTranslation } from 'react-i18next';

const data = [
  [
    'Company Name',
    'Company Country',
    'Product Description',
    'Transaction ID',
    'HS Code(6)',
  ],
  [
    'A. J. J. STORES SOCIEDAD ANONIMA.',
    'ES',
    'Pure-bred breeding animals: This includes animals specifically raised and intended for breeding purposes, ensuring the continuation of their specific lineage.',
    'abc',
    ''
  ],
  [
    'EUROFINS AGROAMBIENTAL, S.A.',
    'ES',
    'Live horses, for pure-bred breeding',
    'A24428161',
    '',
  ],
];

export default function SampleCsvLink() {
  const { t } = useTranslation('default');
  return <CsvSyncButton text={t('download-sample-csv')} data={data} />;
}
